import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _excluded = ["children", "data-testid", "title"],
    _excluded2 = ["children", "data-testid", "subTitle", "title", "headerAction"];

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;

import React from 'react';
import { Drawer as AntDrawer } from 'antd';
import styled from 'styled-components';
import chroma from 'chroma-js';
import { identity } from 'lodash-es';
import Typography from './Typography';
import WithSideNavigation from './WithSideNavigation';
import CollapsiblePaper from './CollapsiblePaper';
var Drawer = styled(AntDrawer)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  .ant-drawer-body {\n    background-color: ", ";\n    padding: 0;\n  }\n"])), function (props) {
  return chroma(props.theme.colors.grey).brighten(0.25).hex();
});
var Paper = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  max-width: 50rem;\n  padding: 2rem 3rem;\n  margin: 2rem auto;\n  border-radius: 4px;\n\n  @media only screen and (max-width: ", ") {\n    padding-left: 1rem;\n    padding-right: 1rem;\n    margin: 0;\n  }\n"])), function (props) {
  return props.theme.colors.light;
}, function (props) {
  var _props$theme$breakpoi;

  return ((_props$theme$breakpoi = props.theme.breakpoints) === null || _props$theme$breakpoi === void 0 ? void 0 : _props$theme$breakpoi.sm) && '576px';
});
var Title = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  text-align: center;\n  margin-bottom: 2rem;\n\n  h3 {\n    margin: 0;\n  }\n"])), function (props) {
  return props.theme.colors.light;
});
var Body = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral([""])));
var Container = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  height: 100%;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n"])), function (props) {
  return props.theme.colors.light;
});
var ContainerHeader = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["&& {\n  border-bottom: 1px solid ", ";\n  display: flex;\n  justify-content: space-between;\n  padding: ", ";\n  padding-bottom: 1rem;\n  padding-top: 3rem;\n  width: 100%;\n\n  ", "\n}"])), function (props) {
  return props.theme.colors.grey;
}, function (props) {
  return props.theme.layout.mainLayoutSection.padding;
}, function (props) {
  return props.theme.layout.mainLayoutSection.responsivePadding && "\n    @media only screen and (max-width: ".concat(props.theme.breakpoints.sm, ") {\n      padding: ").concat(props.theme.layout.mainLayoutSection.responsivePadding, ";\n    } \n  ");
});
var ContainerTitle = styled(Title)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  text-align: left;\n  margin: 0;\n"])));
var ContainerBody = styled.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  padding: ", ";\n  padding-top: 1rem;\n  margin-bottom: 1rem;\n  overflow: auto;\n\n  ", "\n"])), function (props) {
  return props.theme.layout.mainLayoutSection.padding;
}, function (props) {
  return props.theme.layout.mainLayoutSection.responsivePadding && "\n    @media only screen and (max-width: ".concat(props.theme.breakpoints.sm, ") {\n      padding: ").concat(props.theme.layout.mainLayoutSection.responsivePadding, ";\n    } \n  ");
});

var FullScreenDrawer = function FullScreenDrawer(_ref) {
  var children = _ref.children,
      dataTestId = _ref['data-testid'],
      _ref$visible = _ref.visible,
      visible = _ref$visible === void 0 ? false : _ref$visible,
      _ref$destroyOnClose = _ref.destroyOnClose,
      destroyOnClose = _ref$destroyOnClose === void 0 ? false : _ref$destroyOnClose,
      _ref$placement = _ref.placement,
      placement = _ref$placement === void 0 ? 'bottom' : _ref$placement,
      _ref$closable = _ref.closable,
      closable = _ref$closable === void 0 ? true : _ref$closable,
      _ref$onClose = _ref.onClose,
      onClose = _ref$onClose === void 0 ? identity : _ref$onClose;
  return /*#__PURE__*/React.createElement(Drawer, {
    closable: closable,
    "data-testid": dataTestId,
    destroyOnClose: destroyOnClose,
    height: "100vh",
    onClose: onClose,
    placement: placement,
    push: {
      distance: 0
    },
    visible: visible,
    width: "100%"
  }, children);
};

FullScreenDrawer.Paper = function (_ref2) {
  var children = _ref2.children,
      dataTestId = _ref2['data-testid'],
      _ref2$title = _ref2.title,
      title = _ref2$title === void 0 ? '' : _ref2$title,
      otherProps = _objectWithoutProperties(_ref2, _excluded);

  return /*#__PURE__*/React.createElement(Paper, _extends({
    "data-testid": dataTestId
  }, otherProps), title && /*#__PURE__*/React.createElement(Title, null, /*#__PURE__*/React.createElement(Typography.Title, {
    "data-testid": "".concat(dataTestId, "Title"),
    level: 3
  }, title)), /*#__PURE__*/React.createElement(Body, null, children));
};

FullScreenDrawer.Container = function (_ref3) {
  var children = _ref3.children,
      dataTestId = _ref3['data-testid'],
      _ref3$subTitle = _ref3.subTitle,
      subTitle = _ref3$subTitle === void 0 ? '' : _ref3$subTitle,
      _ref3$title = _ref3.title,
      title = _ref3$title === void 0 ? '' : _ref3$title,
      _ref3$headerAction = _ref3.headerAction,
      headerAction = _ref3$headerAction === void 0 ? '' : _ref3$headerAction,
      otherProps = _objectWithoutProperties(_ref3, _excluded2);

  return /*#__PURE__*/React.createElement(Container, _extends({
    "data-testid": dataTestId
  }, otherProps), (title || subTitle || headerAction) && /*#__PURE__*/React.createElement(ContainerHeader, null, /*#__PURE__*/React.createElement(ContainerTitle, null, title && /*#__PURE__*/React.createElement(Typography.Title, {
    "data-testid": "".concat(dataTestId, "Title"),
    level: 3
  }, title), subTitle && /*#__PURE__*/React.createElement(Typography.Title, {
    "data-testid": "".concat(dataTestId, "SubTitle"),
    level: 5
  }, subTitle)), headerAction), /*#__PURE__*/React.createElement(ContainerBody, null, children));
};

FullScreenDrawer.WithSideNavigation = WithSideNavigation;
FullScreenDrawer.CollapsiblePaper = CollapsiblePaper;
export default FullScreenDrawer;